import Stack from "@mui/material/Stack";
import { Theme } from "../../data/style/Theme";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { SecondaryTitle } from "../../data/style/Style";

const TextInput = (props) => {
  let {
    label,
    type,
    re,
    error,
    textError,
    step,
    onChange,
    val,
    multi,
    rows,
    inputName,
    de,
    disabled,
    required,
    placeholder,
    icon,
  } = props;

  return (
    <Stack gap={1} width={"100%"}>
      <SecondaryTitle>{label}</SecondaryTitle>
      <TextField
        name={inputName}
        inputRef={re}
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        value={val}
        rows={rows}
        variant="standard"
        onChange={onChange}
        defaultValue={de}
        required={required}
        error={error}
        multiline={multi}
        helperText={textError}
        sx={{
          border: 1,
          borderRadius: 3,
          p: 1,
          background: Theme.palette.card,
          borderColor: Theme.palette.borderLight,
          width: "95%",
          fontSize: "10px",

          "&:active": {
            borderBottom: "red",
          },
        }}
        InputProps={{
          disableUnderline: true,
          startAdornment: icon ? (
            <InputAdornment position="start">
              <span style={{ fontSize: "1.1rem" }}>{icon}</span>
            </InputAdornment>
          ) : undefined,
          sx: {
            fontSize: "0.8rem",
          },
        }}
        inputProps={{
          step: type === "number" ? step : 0,
          sx: {
            color: Theme.palette.text,
            fontFamily: "DM sans",
          },
        }}
      />
    </Stack>
  );
};

export default TextInput;
